import ReconnectingWebSocket from 'reconnecting-websocket';

import { EventRegister } from './event-listeners';

export default class WebsocketsClient {

    ws: any
    isOpen: boolean

    constructor() {
        this.isOpen = false;

        this.initConnection();
    }

    async initConnection() {

        // async url provider
        const urlProvider = async () => {

            let wsUrl = 'wss://api.historic.ro';

            if (process.env.NODE_ENV == 'development') {
                wsUrl = 'ws://localhost:8888';
            }

            let accessToken = '';
            try {
                // Get user data from localstorage
                let userData: any;
                const userDataString = localStorage.getItem('hud');
                if (userDataString) {
                    try {
                        userData = JSON.parse(userDataString);
                        accessToken = userData ? userData.token : '';
                    } catch (e) {

                    }
                }
            } catch (e) {
                console.log(e);
            }

            return `${wsUrl}?token=${accessToken}`;

        };

        const options = {
            connectionTimeout: 3500,
            reconnectionDelayGrowFactor: 2,
            minReconnectionDelay: 10,
            maxRetries: 1000,
            debug: true
        };

        this.ws = new ReconnectingWebSocket(urlProvider, [], options);

        this.events();
    }

    events() {
        EventRegister.on('ws.opened', () => {
            if (this.isOpen) {
                EventRegister.emit('ws.open');
            }
        });

        EventRegister.on('ws.reconnect', () => {
            this.ws.reconnect(301, 'Update the login token');
        });

        this.ws.addEventListener('open', () => {
            this.isOpen = true;
            EventRegister.emit('ws.open');
        });

        this.ws.addEventListener('message', (e: any) => {
            EventRegister.emit('ws.message', e.data);
        });

        this.ws.addEventListener('close', (e: any) => {
            this.isOpen = false;
            EventRegister.emit('ws.close', e);
        });

        this.ws.addEventListener('error', (e: any) => {
            this.isOpen = false;
            EventRegister.emit('ws.error', e);
        });

        EventRegister.on('ws.send', (mdata: any) => {
            if (this.isOpen) {
                this.ws.send(JSON.stringify({
                    eventName: mdata.eventName,
                    data: mdata.data,
                }));
            }
        });
    }
}


export class WebsocketsListener {

    private _wsListener: any

    private _wsListenerOpen: any

    private _wsListenerOpenMultiple: any

    private _wsListenerError: any

    private _wsListenerClose: any

    private _listeners: { count: number, refs: any } = {
        count: 0,
        refs: {},
    }

    constructor() {
        this._events();
    }

    _events() {
        this._wsListener = EventRegister.on('ws.message', (data: any) => {
            const mdata = JSON.parse(data);

            this.emit(mdata.eventName, mdata);
        });
    }

    _on(eventName: string, method: string, callback: Function) {
        const eventIdentifier = `${eventName}.${method}`;

        this._listeners.count++;

        const eventId = `l${this._listeners.count}`;

        this._listeners.refs[eventId] = {
            name: eventIdentifier,
            callback,
        };

        return eventId;
    }

    off(id?: any) {
        if (typeof id === 'string') {
            return delete this._listeners.refs[id];
        }
        return false;
    }

    _send(eventName: string, method: string, payload?: any) {
        EventRegister.emit('ws.send', {
            eventName: `${eventName}.${method}`,
            data: payload || {},
        });
    }

    emit(eventName: string, data: any) {
        Object.keys(this._listeners.refs).forEach((_id) => {
            if (this._listeners.refs[_id] && eventName === this._listeners.refs[_id].name) {
                this._listeners.refs[_id].callback(data.success, data.success ? data.data : data.error);
            }
        });
    }

    destroy() {
        EventRegister.removeEventListener(this._wsListener);
        EventRegister.removeEventListener(this._wsListenerOpen);
        EventRegister.removeEventListener(this._wsListenerOpenMultiple);
        EventRegister.removeEventListener(this._wsListenerClose);
        EventRegister.removeEventListener(this._wsListenerError);
    }

    reconnect(callback?: Function) {
        EventRegister.emit('ws.reconnect');

        const tempOpenListener = EventRegister.on('ws.open', () => {
            if (callback) {
                callback();
                EventRegister.removeEventListener(tempOpenListener);
            }
        });
    }

    onOpen(callback: Function) {
        let wasCalled = false;

        this._wsListenerOpen = EventRegister.on('ws.open', () => {
            if (!wasCalled) {
                callback();
                wasCalled = true;
            }
        });

        EventRegister.emit('ws.opened');
    }

    onOpenMultiple(callback: Function) {
        this._wsListenerOpenMultiple = EventRegister.on('ws.open', () => {
            callback();
        });

        EventRegister.emit('ws.opened');
    }

    onError(callback: Function) {
        this._wsListenerError = EventRegister.on('ws.error', (data: any) => {
            callback(data);
        });
    }

    onClose(callback: Function) {
        this._wsListenerClose = EventRegister.on('ws.close', (data: any) => {
            callback(data);
        });
    }

    onGet(eventName: string, callback: Function) {
        return this._on(eventName, 'get', callback);
    }

    onPost(eventName: string, callback: Function) {
        return this._on(eventName, 'post', callback);
    }

    onPut(eventName: string, callback: Function) {
        return this._on(eventName, 'put', callback);
    }

    onDelete(eventName: string, callback: Function) {
        return this._on(eventName, 'delete', callback);
    }

    sendGet(eventName: string, payload?: any) {
        return this._send(eventName, 'get', payload);
    }

    sendPost(eventName: string, payload?: any) {
        return this._send(eventName, 'post', payload);
    }

    sendPut(eventName: string, payload?: any) {
        return this._send(eventName, 'put', payload);
    }

    sendDelete(eventName: string, payload?: any) {
        return this._send(eventName, 'delete', payload);
    }

    async setAuthState(loggedIn: boolean, user?: any) {
        if (loggedIn) {
            try {
                localStorage.setItem('hud', JSON.stringify(user));
            } catch (e) {
                console.log('Set access token to storage error : ', e);
            }
        } else {
            try {
                localStorage.removeItem('hud');
            } catch (e) {
                console.log('Remove access token to storage error : ', e);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/ws.ts